import { Button as MuiButton } from '@mui/material'
import { styled } from '@mui/material/styles'

// TODO: Add support for MUI themeing
const Button = styled(MuiButton)(() => ({
	width: 'auto',
	height: '50px',
	background: '#293368',
	borderColor: '#8476ef',
	fontSize: '14px',
	fontWeight: '400',
	textTransform: 'uppercase',
	'& :hover': {
		borderColor: '#8476ef'
	}
}))

export default Button